import React from "react";
import SimpleLookupPage from "./SimpleLookupPage";
import useRegions from "../../hooks/useRegions";

export default function RegionsPage() {
    const {
        regions,
        loading,
        error,
        fetchRegions,
        createRegion,
        updateRegion,
        deleteRegion,
    } = useRegions();

    return (
        <SimpleLookupPage
            title="Regionen"
            itemLabel="Region"
            searchLabel="Regionen suchen"
            items={regions}
            loading={loading}
            error={error}
            fetchItems={fetchRegions}
            createItem={createRegion}
            updateItem={updateRegion}
            deleteItem={deleteRegion}
            extraColumns={[
                {
                    id: "company_count",
                    label: "Firmenzuordnungen",
                    render: (item) => Number(item.company_count || 0),
                    sortValue: (item) => Number(item.company_count || 0),
                },
            ]}
        />
    );
}
